import jQuery from 'jquery/dist/jquery';
import * as bootstrap from 'bootstrap'
import Utils from '../../../utils'
import DefaultController from "../../defaultController";
import RolesEntity from "../entity";
import Swal from "sweetalert2";

export default class RoleList extends DefaultController {
    tableElem: any;
    datatable: any;
    private editModal: any;

    async init() {
        this.entity = "roles";
        this.tableElem = jQuery('.datatables-users')
        this.editModal = new bootstrap.Modal((document.querySelector("#editRole") as HTMLElement));
        this.createTable();
        await super.init();
    }

    getEntityData(elem: any) {
        return RolesEntity.getEntityData(elem)
    }

    bindListeners() {
        this.tableElem.delegate(".delete-record", "click", async (e: any) => {
            const confirm = await Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                customClass: {
                    confirmButton: 'btn btn-primary me-3',
                    cancelButton: 'btn btn-label-secondary'
                },
                buttonsStyling: false
            })
            if(confirm.value === true) {
                const id = e.currentTarget.getAttribute("data-id")
                const r = await Utils.entity.destroy(id, this.entity)
                if (r.status === 200) {
                    this.toastr.success(`${Utils.translate('role.name')} ${Utils.translate('generic.deleted')}`, `${Utils.translate('generic.success')}`)
                } else {
                    this.toastr.error(`${Utils.translate('role.name')} ${Utils.translate('generic.messages.not_deleted')}`, `${Utils.translate('generic.error')}`)
                }
                this.datatable.ajax.reload();
            }
        });
        this.tableElem.delegate(".edit-record", "click", async (e: any) => {
            const id = e.currentTarget.getAttribute("data-id")
            const requestData = await Utils.entity.get(id, this.entity)
            if (requestData.status === 200) {
                const data = requestData.data[0]
                const form = (document.querySelector("#editRoleForm") as HTMLFormElement);
                form.reset();
                await Utils.updateElements(data, '', form)

                jQuery("#editRoleForm #role_members").val("").trigger("change");
                data.users.forEach((user: any) => {
                    const option = new Option(user.name, user.uuid, true, true);
                    jQuery("#editRoleForm #role_members").append(option).trigger('change');

                    // manually trigger the `select2:select` event
                    jQuery("#editRoleForm #role_members").trigger({
                        type: 'select2:select',
                        params: {
                            data: user
                        }
                    });
                })


                jQuery("#editRoleForm #role_customers").val("").trigger("change");
                data.customers.forEach((customer: any) => {
                    const option = new Option(customer.name, customer.uuid, true, true);
                    jQuery("#editRoleForm #role_customers").append(option).trigger('change');

                    // manually trigger the `select2:select` event
                    jQuery("#editRoleForm #role_customers").trigger({
                        type: 'select2:select',
                        params: {
                            data: customer
                        }
                    });
                })
                this.editModal.show();
            }

        });
        (document.querySelector("#addNewRoleForm") as HTMLFormElement).addEventListener("submit", async (e) => {
            e.preventDefault();
            const elem = document.querySelector("#addNewRoleForm") as HTMLFormElement;
            const valid = elem.checkValidity();
            if (valid) {
                const r = await Utils.entity.upsert(this.getEntityData(elem), this.entity)
                if (r.status === 200) {
                    await this.datatable.ajax.reload();
                    const bsElem = bootstrap.Offcanvas.getInstance((document.querySelector("#offcanvasAddRole") as HTMLElement))
                    if (bsElem) {
                        bsElem.hide();
                    }
                    elem.reset();
                    this.toastr.success(`${Utils.translate('role.name')} ${Utils.translate('generic.messages.created')}`, `${Utils.translate('generic.success')}`)
                }
            }
        });

        (document.querySelector("#editRoleForm") as HTMLFormElement).addEventListener("submit", async (e) => {
            e.preventDefault();
            const elem = document.querySelector("#editRoleForm") as HTMLFormElement;
            const valid = elem.checkValidity();
            if (valid) {
                const r = await Utils.entity.upsert(this.getEntityData(elem), this.entity)
                if (r.status === 200) {
                    await this.datatable.ajax.reload();
                    this.editModal.hide();
                    this.toastr.success(`${Utils.translate('role.name')} ${Utils.translate('generic.saved')}`, `${Utils.translate('generic.success')}`)
                }
            }
        })

        document.querySelectorAll(".permission_all").forEach((btn: any) => {
            btn.addEventListener("click", (e: any) => {
                e.preventDefault();
                const tr = btn.closest("tr")
                const read = (tr.querySelector("input[data-type='can_read']") as HTMLInputElement).checked
                const create = (tr.querySelector("input[data-type='can_create']") as HTMLInputElement).checked
                const update = (tr.querySelector("input[data-type='can_update']") as HTMLInputElement).checked
                const destroy = (tr.querySelector("input[data-type='can_destroy']") as HTMLInputElement).checked
                const navbar = (tr.querySelector("input[data-type='can_read_navbar']") as HTMLInputElement).checked
                if (read && create && update && destroy && navbar) {
                    (tr.querySelector("input[data-type='can_read']") as HTMLInputElement).checked = false;
                    (tr.querySelector("input[data-type='can_create']") as HTMLInputElement).checked = false;
                    (tr.querySelector("input[data-type='can_update']") as HTMLInputElement).checked = false;
                    (tr.querySelector("input[data-type='can_destroy']") as HTMLInputElement).checked = false;
                    (tr.querySelector("input[data-type='can_read_navbar']") as HTMLInputElement).checked = false;
                } else {
                    (tr.querySelector("input[data-type='can_read']") as HTMLInputElement).checked = true;
                    (tr.querySelector("input[data-type='can_create']") as HTMLInputElement).checked = true;
                    (tr.querySelector("input[data-type='can_update']") as HTMLInputElement).checked = true;
                    (tr.querySelector("input[data-type='can_destroy']") as HTMLInputElement).checked = true;
                    (tr.querySelector("input[data-type='can_destroy']") as HTMLInputElement).checked = true;
                    (tr.querySelector("input[data-type='can_read_navbar']") as HTMLInputElement).checked = true;
                }
            })
        })
    }

    createTable() {
        this.datatable = new DataTable(this.tableElem, {
            initComplete: () => {
                this.tableElem.closest(".card").find(".loading-body").addClass("d-none")
                this.tableElem.closest(".card").find(".card-datatable").removeClass("d-none")
            },
            ajax: `/api/v1/roles`,
            columns: [
                {data: 'name'},
                {data: 'uuid'},
                {data: 'uuid'}
            ],
            columnDefs: [
                {
                    targets: 0,
                    render: (data: any, type: any, full: any, meta: any) => {
                        return data;
                    },
                },
                {
                    targets: 1,
                    render: (data: any, type: any, full: any, meta: any) => {
                        return full.users.length;
                    },
                },
                {
                    targets: 2,
                    searchable: false,
                    orderable: false,
                    render: (data: any, type: any, full: any, meta: any) => {
                        return `<div class="d-flex align-items-center justify-content-end">
                                  <a href="#" data-id="${data}" class="text-body edit-record">
                                    <i class="ti ti-edit ti-sm me-2"></i>
                                  </a>
                                  <a href="#" data-id="${data}" class="text-body delete-record">
                                    <i class="ti ti-trash ti-sm mx-2"></i>
                                  </a>
                                </div>`
                    },
                }
            ],
            processing: true,
            dom:
                '<"row me-2 align-items-center"' +
                '<"col-md-2"<"me-3 m-3"l>>' +
                '<"col-md-10"<"dt-action-buttons text-xl-end text-lg-start text-md-end text-start d-flex align-items-center justify-content-end flex-md-row flex-column mb-3 mb-md-0"fB>>' +
                '>t' +
                '<"row mx-2 align-items-center justify-content-between"' +
                '<"col-6"i>' +
                '<"col-2 mt-3"p>' +
                '>',

            language: {
                sLengthMenu: '_MENU_',
                search: '',
                searchPlaceholder: `${Utils.translate('generic.search')}...`,
                "zeroRecords":    `${Utils.translate('generic.datatable.no_results')}`,
                "emptyTable":     `${Utils.translate('generic.datatable.no_results')}`,
                "paginate": {
                    "first":      `${Utils.translate('generic.datatable.pagination.first')}`,
                    "last":       `${Utils.translate('generic.datatable.pagination.last')}`,
                    "next":       `${Utils.translate('generic.datatable.pagination.next')}`,
                    "previous":   `${Utils.translate('generic.datatable.pagination.previous')}`
                },
                "info":           `${Utils.translate('generic.datatable.info.info')}`,
                "infoEmpty":      `${Utils.translate('generic.datatable.info.empty')}`,
                "infoFiltered":   `${Utils.translate('generic.datatable.info.filtered')}`,
            },
            buttons: [
                {
                    text: `<i class="ti ti-plus me-0 me-sm-1 ti-xs"></i><span class="d-none d-sm-inline-block">${Utils.translate('generic.add')}</span>`,
                    className: 'dt-button add-new btn btn-primary m-2',
                    attr: {
                        'data-bs-toggle': 'offcanvas',
                        'data-bs-target': '#offcanvasAddRole'
                    }
                }
            ]
        });
    }
}